import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { RadarPlot } from "../components/RadarPlot";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.radar_tool_name()}
        toolPath="/radar-chart"
      />
      <SciHeader title={m.radar_h1()} intro={m.radar_intro()} />

      <RadarPlot />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.radar_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.radar_ex1(), m.radar_ex2(), m.radar_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.radar_faq_q1(), a: m.radar_faq_a1() },
          { q: m.radar_faq_q2(), a: m.radar_faq_a2() },
          { q: m.radar_faq_q3(), a: m.radar_faq_a3() },
          { q: m.radar_faq_q4(), a: m.radar_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
